import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { ConnectionSignStatusService } from '../../../../_core/domain/services/connection-sign/connection-sign.service';
import { setConnectionSignStatus } from './connection-sign.actions';
import { selectIsConnected } from './connection-sign.selectors';

@Injectable({
  providedIn: 'root'
})
export class ConnectionSignStoreAdapter implements ConnectionSignStatusService {

  //TODO: Migrate-To-Signal in v18!
  constructor(private store: Store) { }

  public setConnectionStatus(isConnected: boolean): void {
    this.store.dispatch(setConnectionSignStatus({ isConnected }));
  }

  public selectConnectionStatus(): Observable<boolean> {
    return this.store.select(selectIsConnected.isConnected);
  }
}
